import { render, staticRenderFns } from "./HandlingIncubation.vue?vue&type=template&id=6201d860&"
import script from "./HandlingIncubation.vue?vue&type=script&lang=js&"
export * from "./HandlingIncubation.vue?vue&type=script&lang=js&"
import style0 from "./HandlingIncubation.vue?vue&type=style&index=0&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports